import {
  type EspecieRequest,
  type EspecieFormErrors,
  type PresentacionRequest,
  type PresentacionFormErrors,
  type CalibreRequest,
  type CalibreFormErrors
} from '../types/especie';

export class EspecieValidation {
  static validateEspecie(especie: EspecieRequest): EspecieFormErrors {
    const errors: EspecieFormErrors = {};

    if (!especie.nombreComun?.trim()) {
      errors.nombreComun = 'El nombre común es requerido';
    }

    if (!especie.nombreCientifico?.trim()) {
      errors.nombreCientifico = 'El nombre científico es requerido';
    }

    return errors;
  }

  static isValidEspecie(especie: EspecieRequest): boolean {
    const errors = this.validateEspecie(especie);
    return Object.keys(errors).length === 0;
  }

  static validatePresentacion(presentacion: PresentacionRequest): PresentacionFormErrors {
    const errors: PresentacionFormErrors = {};

    if (!presentacion.descripcion?.trim()) {
      errors.descripcion = 'La descripción es requerida';
    }

    if (presentacion.esFresco === undefined || presentacion.esFresco === null) {
      errors.esFresco = 'Debe especificar si es fresco o procesado';
    }

    return errors;
  }

  static isValidPresentacion(presentacion: PresentacionRequest): boolean {
    const errors = this.validatePresentacion(presentacion);
    return Object.keys(errors).length === 0;
  }

  static validateCalibre(calibre: CalibreRequest): CalibreFormErrors {
    const errors: CalibreFormErrors = {};

    if (!calibre.descripcion?.trim()) {
      errors.descripcion = 'La descripción es requerida';
    }

    return errors;
  }

  static isValidCalibre(calibre: CalibreRequest): boolean {
    const errors = this.validateCalibre(calibre);
    return Object.keys(errors).length === 0;
  }
}